import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import { BUS_MAINTENANCE_STATUS_TYPE } from '../../../../../config/constants';
import busMaintenanceBasicInformationPropTypes from '../proptypes/BusMaintenanceBasicInformationPropTypes';
import { tzNormalizeDate } from '../../../../../utils/date';
import { DATE_TIME_FORMAT } from '../../../../../config/locale';

const BusMaintenanceStayBasicInformationResource = ({
  id,
  maintenanceStayStatus,
  registeredBus,
  originCity,
  observation,
  estimatedArrivalDate,
  estimatedCompletionDate,
}) => (
  <>
    <ResourceProperty label="ID:">{id || '-'}</ResourceProperty>
    <ResourceProperty label="Bus:">
      {registeredBus.companyBusId || '-'}
    </ResourceProperty>
    <ResourceProperty label="Ciudad de Origen:">
      {originCity.name || '-'}
    </ResourceProperty>
    <ResourceProperty label="Fecha Estimada de Llegada:">
      {estimatedArrivalDate
        ? tzNormalizeDate({
            date: estimatedArrivalDate,
            format: DATE_TIME_FORMAT,
          })
        : '-'}
    </ResourceProperty>
    <ResourceProperty label="Fecha Estimada de Entrega:">
      {estimatedCompletionDate
        ? tzNormalizeDate({
            date: estimatedCompletionDate,
            format: DATE_TIME_FORMAT,
          })
        : '-'}
    </ResourceProperty>
    <ResourceProperty label="Tipo de Mantenimiento:">
      {maintenanceStayStatus
        ? BUS_MAINTENANCE_STATUS_TYPE[maintenanceStayStatus].label
        : '-'}
    </ResourceProperty>
    <h5>Observaciones</h5>
    <p>{observation}</p>
  </>
);

BusMaintenanceStayBasicInformationResource.propTypes =
  busMaintenanceBasicInformationPropTypes;

export default BusMaintenanceStayBasicInformationResource;
